import React, { FC, useCallback, useEffect, useState, useContext, useRef } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { download, get, post } from "../fetchers/fetchers";
import fileDownload from 'js-file-download';

import { useParams } from "react-router";
import { API_URL } from "../env";

import {
    Accordion, AccordionSummary,
    Box,
    Button,
    Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Paper,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    withStyles
} from "@material-ui/core";
import {

    IControlMeasure, IControlMeasureAssessment, IControlMeasureCost,
    IControlMeasureFailureMode,
    IProjectFailureMode, IFailureModeAssessment, IRiskAssessment,
    IAssessmentSettings

} from "../types/types";

import ControlMeasureCost from "./control_measure_cost";
import { CloudDownload, ExpandMore, Settings } from "@material-ui/icons";

import { getAssessmentSettings, getControlMeasureCosts } from "../stateManagement/data";
import AssessmentSettingsCost from './assessment_setting_cost';
import { set } from 'date-fns';
import { Alert } from '@material-ui/lab';


interface IControlMeasureCostsProps {
    existing: boolean
}

interface IRouteParams {
    id: string
}



const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

const ControlMeasureCosts: FC<IControlMeasureCostsProps> = ({ existing }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [controlMeasureCosts, setControlMeasureCosts] = useState<IControlMeasureCost[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);
    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [defaultSettingsDlg, setDefaultSettingsDlg] = useState<boolean>(false);
    const [currentAssessmentSettings, setCurrentAssessmentSettings] = useState<IAssessmentSettings>();



    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks.write_access])

    useEffect(() => {

        if (tasks.loaded) {

            setControlMeasures(tasks.controlMeasures)
            setFailureModes(tasks.failureModes)
            setControlMeasureFailureModes(tasks.failureModeControlMeasures)
            setControlMeasureAssessments(tasks.controlMeasureAssessments)
            setControlMeasureCosts(tasks.controlMeasureCosts)
            setFailureModeAssessments(tasks.failureModeAssessments)

        }

    }, [tasks.loaded, tasks.controlMeasureCosts, tasks.controlMeasureAssessments, tasks.failureModeAssessments, tasks.failureModeControlMeasures, tasks.controlMeasures, tasks.failureModes])

    const params = useParams<IRouteParams>()

    const getCMeasureCost = (cm: IControlMeasure): IControlMeasureCost => {
        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        let controlMeasureCost = controlMeasureCosts.find(cma => cma.control_measure_id === cm_id)

        if (controlMeasureCost) {
            return controlMeasureCost
        }
        controlMeasureCost = {
            control_measure_id: cm_id
        }
        return controlMeasureCost
    }

    const setControlMeasureCost = async (controlMeasureCost: IControlMeasureCost) => {
        let c = { ...controlMeasureCost }

        delete c.id
        delete c.created_at

        await post<IControlMeasureCost>(API_URL + "control_measures/" + params.id.toString() + "/costs", c);
        await getControlMeasureCosts(params.id, dispatch)

    }


    const updateControlMeasureCost = useCallback((controlMeasureCost: IControlMeasureCost) => {

        let c = { ...controlMeasureCost }

        delete c.id
        delete c.cssl
        delete c.df
        delete c.annualised_cost
        delete c.cost_adequacy
        delete c.cost_adequacy_id
        delete c.document

        setControlMeasureCost(c).then(() => {
        })
    }, [setControlMeasureCost]);

    const downloadFile = async () => {

        return await download(API_URL + "control_measures/" + params.id.toString() + "/costs/download");
    }

    const getFile = () => {

        downloadFile().then(({ data, filename }) => { fileDownload(data, "assessment_" + params.id + ".csv") })
    }

    const handleCloseDefaultSettingsDlg = () => {
        setDefaultSettingsDlg(false)
    }

    const updateAssessmentSettings = useCallback((currentSettings: IAssessmentSettings) => {
        let c = { ...currentSettings }
        setCurrentAssessmentSettings(c)
    }, [setCurrentAssessmentSettings]);


    const pushAssessmentSettings = async (assessmentSettings: IAssessmentSettings) => {
        let c = { ...assessmentSettings }
        delete c.id

        await post<IAssessmentSettings>(API_URL + "assessment_project/" + params.id.toString() + "/settings", c);

    }

    const render_project_settings_dlg = () => {
        return (
            <Dialog open={defaultSettingsDlg} onClose={handleCloseDefaultSettingsDlg} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Edit default settings</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <AssessmentSettingsCost updateAssessmentSettings={updateAssessmentSettings} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDefaultSettingsDlg} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleOpenAreaYouSure} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }


    const handleOpenDefaultSettingsDlg = () => {
        setDefaultSettingsDlg(true)
    }

    const handleOpenAreaYouSure = () => {
        setAreYouSure(true)
    }

    const handleCloseAreaYouSure = () => {
        setAreYouSure(false)
    }

    const handleUpdateCustomSettings = () => {
        if (currentAssessmentSettings) {
            pushAssessmentSettings(currentAssessmentSettings).then(() => {
                getAssessmentSettings(params.id, dispatch)
                getControlMeasureCosts(params.id, dispatch)
            })
        }
        handleCloseAreaYouSure()
        handleCloseDefaultSettingsDlg()
    }



    const renderAreYouSure = () => {
        return (
            <Dialog open={areYouSure} onClose={handleCloseAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Change default settings</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to change the default settings?

                            <Box mt={2}>
                                <Alert severity="warning">
                                    This will update CSSL, Disproportion Ratio, and Annualised Cost for all control measures using default values.
                                </Alert>
                            </Box>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleUpdateCustomSettings} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }


    return (
        <>
            {renderAreYouSure()}
            {render_project_settings_dlg()}

            <Grid container xs={12} lg={12} style={{ padding: 10, width: "100%" }}>

                <Paper variant={"outlined"}
                    style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>

                    {/* {write_access && <Tooltip title="Download costing template" placement={'bottom-end'}>
                        <AddingButton style={{
                            backgroundColor: "rgb(239,88,43)",
                            color: "rgb(255,255,255)"
                        }} onClick={prevState => getFile()}>
                            <CloudDownload fontSize="small" />
                        </AddingButton>
                    </Tooltip>} */}

                    {write_access && <Tooltip title="Settings" placement={'bottom-end'}>
                        <AddingButton style={{
                            backgroundColor: "rgb(239,88,43)",
                            color: "rgb(255,255,255)"
                        }} onClick={prevState => handleOpenDefaultSettingsDlg()}>
                            <Settings fontSize="small" />
                        </AddingButton>
                    </Tooltip>}



                    <Table >

                        <TableHead style={{ position: 'sticky', top: 65, zIndex: 2, backgroundColor: "#ffffff" }}>
                            <TableCell></TableCell>
                            <TableCell>Control Measure</TableCell>
                            <TableCell>Order of magnitude of Costs ($M)</TableCell>
                            <TableCell width={"300px"}>Costs ($) </TableCell>
                            <TableCell>Annualised Cost ($/yr) </TableCell>
                            <TableCell width={"10px"}>Time frame (months)</TableCell>


                            <TableCell>CSSL</TableCell>
                            <TableCell>Disproportion Ratio</TableCell>
                            <TableCell>Implementation Justification</TableCell>
                            <TableCell>Comments</TableCell>
                            <TableCell>Reference</TableCell>
                        </TableHead>
                        <TableBody>

                            {controlMeasures.filter((c) => c.existing === existing).map((cm) => {
                                // check if any of the failure modes are considered
                                let fms_ids = controlMeasureFailureModes.filter(c => cm.uuid === c.control_measure_id)

                                // check if fms_ids are in the considered failure modes
                                // f_considered is undefined if none of the failure modes are considered 
                                let f_considered = fms_ids.filter(f => failureModeAssessments.filter(f => f.consider === true).filter(fa => fa.project_failure_mode_id === f.project_failure_mode_id)).filter(f => f.priority > 0)


                                let cms = controlMeasureAssessments.filter(c => cm.uuid === c.control_measure_id)

                                // check that f_considered project failure modes are in cms
                                cms = cms.filter(c => f_considered.filter(f => f.project_failure_mode_id === c.project_failure_mode_id).length > 0)

                                let considered = cms.find(c => c.considered === true)

                                if (considered) {
                                    return (
                                        <ControlMeasureCost control_measure={cm}
                                            cm_c={getCMeasureCost(cm)}
                                            uControlMeasuresCost={updateControlMeasureCost}
                                        />
                                    )
                                } else {
                                    return <></>
                                }
                            })
                            }
                        </TableBody>
                    </Table>

                    <div>
                        <Typography><small>Note only included control measures are shown</small></Typography>
                    </div>
                </Paper>


            </Grid>
        </>

    );

}

export default ControlMeasureCosts;

